<template>
    <div class="header-search header-search__form-wrap">
        <form @submit.prevent="handleSearch"
            class="header-inner__search-form header-inner__search-form--desktop search-form clearfix"
            role="search">
            <div class="header-search__search-wrap header-inner__search-wrap--desktop"
                :class="{'not-guest': !isGuest}">
                <button type="submit" :aria-label="$t('Search')" class="header-search__form-submit form-control-submit">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.65501 2.01229C6.47163 1.67404 7.34689 1.49994 8.2308 1.49994C9.1147 1.49994 9.98996 1.67404 10.8066 2.01229C11.6232 2.35055 12.3652 2.84634 12.9902 3.47136C13.6152 4.09638 14.111 4.83838 14.4493 5.65501C14.7876 6.47163 14.9617 7.34689 14.9617 8.2308C14.9617 9.1147 14.7876 9.98996 14.4493 10.8066C14.1849 11.445 13.8241 12.0378 13.3807 12.5648L16.331 15.5151C16.5563 15.7404 16.5563 16.1057 16.331 16.331C16.1057 16.5563 15.7404 16.5563 15.5151 16.331L12.5648 13.3807C11.3563 14.3978 9.82261 14.9617 8.2308 14.9617C6.44566 14.9617 4.73364 14.2525 3.47136 12.9902C2.20908 11.7279 1.49994 10.0159 1.49994 8.2308C1.49994 6.44566 2.20908 4.73364 3.47136 3.47136C4.09638 2.84634 4.83838 2.35055 5.65501 2.01229ZM8.2308 2.65377C7.49841 2.65377 6.7732 2.79803 6.09656 3.0783C5.41993 3.35857 4.80512 3.76937 4.28724 4.28725C3.24135 5.33314 2.65377 6.75168 2.65377 8.2308C2.65377 9.70991 3.24135 11.1285 4.28724 12.1743C5.33314 13.2202 6.75168 13.8078 8.2308 13.8078C9.70991 13.8078 11.1285 13.2202 12.1743 12.1743C12.6922 11.6565 13.103 11.0417 13.3833 10.365C13.6636 9.68839 13.8078 8.96318 13.8078 8.2308C13.8078 7.49841 13.6636 6.7732 13.3833 6.09656C13.103 5.41993 12.6922 4.80512 12.1743 4.28725C11.6565 3.76937 11.0417 3.35857 10.365 3.0783C9.68839 2.79803 8.96318 2.65377 8.2308 2.65377Z" fill="currentColor"/>
                    </svg>
                </button>
                <div class="header-search__field">
                    <input
                    name="name"
                    type="text"
                    aria-label="Search"
                    v-model="searchQuery"
                    @input="handleSearchInput"
                    class="header-search__search-input form-control"
                    :placeholder="$t('Search Products') + '...'"
                    autocomplete="off" maxlength="40">
                </div>
                <div class="header-search__filter-chips" v-if="activeFilterChips">
                    <span class="header-search__filter-chips-name">{{ activeFilterChips.label }}</span>
                    <button class="header-search__filter-chips-remove" type="button" @click="activeFilterChips = null"></button>
                </div>
                <div class="header-search__filter" @click="$emit('toggle-filter-catalog')" v-else>
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.0001 6C16.1046 6 17.0001 5.10457 17.0001 4C17.0001 2.89543 16.1046 2 15.0001 2C13.8955 2 13.0001 2.89543 13.0001 4C13.0001 5.10457 13.8955 6 15.0001 6ZM1.25006 4C1.25006 3.58579 1.58585 3.25 2.00006 3.25H11.0001C11.4143 3.25 11.7501 3.58579 11.7501 4C11.7501 4.41421 11.4143 4.75 11.0001 4.75H2.00006C1.58585 4.75 1.25006 4.41421 1.25006 4ZM2.00006 8.25C1.58585 8.25 1.25006 8.58579 1.25006 9C1.25006 9.41421 1.58585 9.75 2.00006 9.75H5.14544C5.44213 10.483 6.16072 11 7.00006 11C8.10463 11 9.00006 10.1046 9.00006 9C9.00006 7.89543 8.10463 7 7.00006 7C6.16072 7 5.44214 7.51704 5.14544 8.25H2.00006ZM11.0001 8.25C10.5858 8.25 10.2501 8.58579 10.2501 9C10.2501 9.41421 10.5858 9.75 11.0001 9.75L16.0001 9.75C16.4143 9.75 16.7501 9.41421 16.7501 9C16.7501 8.58579 16.4143 8.25 16.0001 8.25L11.0001 8.25ZM16.0001 14.75C16.4143 14.75 16.7501 14.4142 16.7501 14C16.7501 13.5858 16.4143 13.25 16.0001 13.25L12.8547 13.25C12.558 12.517 11.8394 12 11.0001 12C9.89551 12 9.00008 12.8954 9.00008 14C9.00008 15.1046 9.89551 16 11.0001 16C11.8394 16 12.558 15.483 12.8547 14.75L16.0001 14.75ZM7.75008 14C7.75008 14.4142 7.41429 14.75 7.00008 14.75L2.00008 14.75C1.58586 14.75 1.25008 14.4142 1.25008 14C1.25008 13.5858 1.58586 13.25 2.00008 13.25L7.00008 13.25C7.41429 13.25 7.75008 13.5858 7.75008 14Z" fill="currentColor"/>
                    </svg>
                </div>
            </div>
        </form>
        <transition name="fade-info">
            <div class="header-search__fiters-wrap" v-if="isFilterCatalogActive">
                <ul class="header-search__fiters-list">
                    <li v-for="(item, index) in filteredCategories" :key="index" class="header-search__fiters-list-item">
                        <button class="header-search__fiters-list-button js-filters-search-desc" @click="choseFilterChips(item)" type="button">
                            <svg v-if="item?.category_icon" width="24" height="24">
                                <use :href="'#' + item.category_icon"></use>
                            </svg>
                            <span>{{ item.label }}</span>
                        </button>
                    </li>
                </ul>
            </div>
        </transition>
        <div class="header-search__search-result search-result" :class="{empty: searchResultCount === 0}" v-if="isSearchResultVisible">
            <SlideUpDown :isActive="isSearchResultShow">
                <div class="list-view">
                    <div class="empty" v-if="searchResultCount === 0">
                        <div class="empty-item">
                            <img class="empty-item__image img-responsive" src="/img/header/empty.svg" alt="Empty">
                            <h3 class="empty-item__title">{{ $t("No results for your search") }}</h3>
                            <p class="empty-item__text">{{ $t("The request you were looking for was not found.") }}{{ $t("Try refining your request") }}</p>
                        </div>
                    </div>
                    <div class="header-search__item-list item-list" v-else>
                        <a v-for="item in searchResultProducts" 
                            :key="item.id"
                            class="header-search__item-product" 
                            :href="item.url">
                            <div class="header-search__item-img">
                                <img class="img-responsive" :src="item.images.icon.src" :alt="item.images.icon.alt" :title="item.images.icon.title">
                            </div>
                            <div class="header-search__item item" :data-title="item.name">
                                <div class="header-search__item-wrapper">
                                    <div class="header-search__item-info">
                                        <div class="header-search__item-title">{{ item.name }}</div>
                                        <div class="header-search__item-qty" v-if="!mobile">
                                            <span class="" v-if="item.active_offer_count">
                                                {{ item.active_offer_count }}&nbsp;{{item.active_offer_count > 1 ? $t("offers") : $t("offer") }}
                                            </span>
                                            <span class="" v-else>
                                                {{ $t("No active offers") }}
                                            </span>
                                        </div>
                                        <div class="card__platforms" v-if="item?.game_platforms && !mobile">
                                            <span v-for="platform in item.game_platforms" :key="platform.id" class="platform" :class="`ico-${platform.id}`"></span>
                                        </div>
                                        <div class="header-search__item-price--mob" v-if="mobile && item.active_offer_count && item.min_price">
                                            <p class="header-search__item-price-label--mob">{{ $t("from") }}</p>
                                            <p class="header-search__item-price-quantity--mob">{{formatCurrency(item.min_price)}}</p>
                                        </div>
                                    </div>
                                    <div class="header-search__item-price" v-if="!mobile">
                                        <p v-if="item.active_offer_count && item.min_price" class="header-search__item-price-label">{{ $t("from") }}</p>
                                        <p v-if="item.active_offer_count && item.min_price" class="header-search__item-price-quantity">{{formatCurrency(item.min_price)}}</p>
                                        <span v-else class="no-offers">{{ $t("No offers") }}</span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="header-search__item-footer" v-if="searchResultCount !== 0">
                        <div class="header-search__item-footer-count">
                            <span class="header-search__count-result">{{ $t("Results found") }}:</span>
                            <span class="header-search__count-sum">{{ searchResultCount }}</span>
                        </div>
                        <a :href="linkViewAll" class="header-search__results-btn">
                            {{ $t("See all results") }}
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.9804 11.6905C15.9804 11.9414 15.8846 12.1922 15.6934 12.3835L9.67365 18.4032C9.29071 18.7862 8.66986 18.7862 8.28708 18.4032C7.9043 18.0205 7.9043 17.3997 8.28708 17.0168L13.6137 11.6905L8.28727 6.36412C7.90449 5.98118 7.90449 5.36051 8.28727 4.97777C8.67004 4.59465 9.2909 4.59465 9.67383 4.97777L15.6936 10.9974C15.8848 11.1888 15.9804 11.4396 15.9804 11.6905Z" fill="#4E8AFF"/>
                            </svg>
                        </a>
                    </div>
                </div>
            </SlideUpDown>
        </div>
    </div>
    <svg v-show="false" aria-hidden="true" style="position: absolute; width: 0; height: 0; overflow: hidden;" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <defs>
            <symbol id="filter-img-software" viewBox="0 0 32 32">
                <path fill="none" stroke="currentColor" stroke-linejoin="miter" stroke-linecap="butt" stroke-miterlimit="4" stroke-width="2" d="M18.481 18.815c0-0.184 0.149-0.333 0.333-0.333h9.185c0.184 0 0.333 0.149 0.333 0.333v9.185c0 0.184-0.149 0.333-0.333 0.333h-9.185c-0.184 0-0.333-0.149-0.333-0.333v-9.185zM18.815 13.519c-0.184 0-0.333-0.149-0.333-0.333v-9.185c0-0.184 0.149-0.333 0.333-0.333h9.185c0.184 0 0.333 0.149 0.333 0.333v9.185c0 0.184-0.149 0.333-0.333 0.333h-9.185zM13.519 13.185c0 0.184-0.149 0.333-0.333 0.333h-9.185c-0.184 0-0.333-0.149-0.333-0.333v-9.185c0-0.184 0.149-0.333 0.333-0.333h9.185c0.184 0 0.333 0.149 0.333 0.333v9.185zM13.185 18.481c0.184 0 0.333 0.149 0.333 0.333v9.185c0 0.184-0.149 0.333-0.333 0.333h-9.185c-0.184 0-0.333-0.149-0.333-0.333v-9.185c0-0.184 0.149-0.333 0.333-0.333h9.185z"></path>
            </symbol>
            <symbol id="filter-img-top-up" viewBox="0 0 32 32">
                <path fill="currentColor" d="M13 16.528v6.805h-6.333c-0.368 0-0.667-0.299-0.667-0.667v-8.333h1.284c0.365 0.737 1.013 1.193 1.658 1.471 0.425 0.184 0.892 0.309 1.366 0.39l-1.932 1.647c-0.42 0.358-0.47 0.99-0.112 1.41s0.99 0.47 1.41 0.112l3.325-2.836zM6 12.333v-3c0-0.368 0.298-0.667 0.667-0.667h6.333v2.428c-0.759-0.687-1.775-1.312-2.828-1.414-0.556-0.054-1.148 0.039-1.684 0.378-0.534 0.338-0.921 0.863-1.175 1.513-0.101 0.258-0.178 0.511-0.231 0.761h-1.082zM15 14.303v-0.713c0.193-0.315 0.478-0.668 0.84-0.999 0.607-0.555 1.241-0.876 1.693-0.92 0.201-0.019 0.33 0.019 0.423 0.077 0.095 0.060 0.245 0.202 0.382 0.552 0.248 0.634 0.182 0.963 0.109 1.124-0.080 0.176-0.268 0.371-0.668 0.544-0.748 0.323-1.854 0.397-2.779 0.335zM15 17.013l2.757 2.351c0.42 0.358 1.051 0.308 1.41-0.112s0.308-1.051-0.112-1.41l-1.918-1.636c0.498-0.081 0.989-0.209 1.435-0.402 0.645-0.278 1.293-0.735 1.658-1.471h5.771v8.333c0 0.368-0.299 0.667-0.667 0.667h-10.333v-6.321zM26 12.333h-5.568c-0.053-0.249-0.13-0.503-0.231-0.761-0.254-0.65-0.641-1.175-1.175-1.513-0.536-0.34-1.129-0.432-1.684-0.378-0.841 0.081-1.66 0.497-2.342 1.011v-2.025h10.333c0.368 0 0.667 0.298 0.667 0.667v3zM14 25.333h11.333c1.473 0 2.667-1.194 2.667-2.667v-13.333c0-1.473-1.194-2.667-2.667-2.667h-18.667c-1.473 0-2.667 1.194-2.667 2.667v13.333c0 1.473 1.194 2.667 2.667 2.667h7.333zM9.176 12.301c0.137-0.35 0.287-0.492 0.382-0.552 0.093-0.059 0.221-0.097 0.422-0.077 0.452 0.043 1.086 0.365 1.693 0.92 0.545 0.498 0.916 1.045 1.060 1.441-0.004 0.034-0.007 0.068-0.010 0.103l-0.195 0.166c-0.928 0.065-2.042-0.009-2.793-0.333-0.4-0.173-0.588-0.368-0.668-0.544-0.073-0.161-0.139-0.49 0.109-1.124z"></path>
            </symbol>
            <symbol id="filter-img-game-points" viewBox="0 0 32 32">
                <path fill="currentColor" d="M27.111 6h-2.222v-1.111c-0.001-0.589-0.235-1.154-0.652-1.571s-0.981-0.651-1.571-0.652h-13.333c-0.589 0.001-1.154 0.235-1.571 0.652s-0.651 0.981-0.652 1.571v1.111h-2.222c-0.589 0.001-1.154 0.235-1.571 0.652s-0.651 0.982-0.652 1.571v3.333c0.001 1.178 0.47 2.308 1.303 3.141s1.963 1.302 3.141 1.303h0.358c0.463 1.701 1.411 3.23 2.729 4.401s2.948 1.933 4.691 2.193v4.518h-5.556v2.222h13.333v-2.222h-5.556v-4.521c1.766-0.218 3.425-0.964 4.761-2.139s2.286-2.727 2.728-4.451h0.289c1.178-0.001 2.308-0.47 3.141-1.303s1.302-1.963 1.303-3.141v-3.333c-0.001-0.589-0.235-1.154-0.651-1.571s-0.982-0.651-1.571-0.652zM7.111 13.778c-0.589-0.001-1.154-0.235-1.571-0.651s-0.651-0.982-0.652-1.571v-3.333h2.222v5.556zM22.667 13.778c0 0.893-0.179 1.777-0.527 2.599s-0.858 1.566-1.499 2.188-1.401 1.108-2.233 1.43c-0.833 0.322-1.722 0.474-2.614 0.447-1.769-0.11-3.428-0.898-4.631-2.2s-1.858-3.017-1.829-4.789v-8.563h13.333v8.889zM27.111 11.556c-0.001 0.589-0.235 1.154-0.651 1.571s-0.981 0.651-1.571 0.651v-5.556h2.222v3.333z"></path>
            </symbol>
            <symbol id="filter-img-download" viewBox="0 0 32 32">
                <path fill="currentColor" d="M8.726 28.121c0-0.669 0.543-1.212 1.212-1.212h12.121c0.669 0 1.212 0.543 1.212 1.212s-0.543 1.212-1.212 1.212h-12.121c-0.669 0-1.212-0.543-1.212-1.212z"></path>
                <path fill="currentColor" d="M6.303 5.091c-0.321 0-0.63 0.128-0.857 0.355s-0.355 0.536-0.355 0.857v15.757c0 0.321 0.128 0.63 0.355 0.857s0.536 0.355 0.857 0.355h19.393c0.321 0 0.63-0.128 0.857-0.355s0.355-0.536 0.355-0.857v-15.757c0-0.321-0.128-0.63-0.355-0.857s-0.536-0.355-0.857-0.355h-19.393zM3.732 3.732c0.682-0.682 1.607-1.065 2.571-1.065h19.393c0.964 0 1.889 0.383 2.571 1.065s1.065 1.607 1.065 2.571v15.757c0 0.964-0.383 1.889-1.065 2.571s-1.607 1.065-2.571 1.065h-19.393c-0.964 0-1.889-0.383-2.571-1.065s-1.065-1.607-1.065-2.571v-15.757c0-0.964 0.383-1.889 1.065-2.571z"></path>
            </symbol>
            <symbol id="filter-img-keys" viewBox="0 0 32 32">
                <path fill="currentColor" d="M18.618 4.679c2.261 0.716 3.832 1.58 5.011 2.759s2.042 2.75 2.759 5.011c0.029 0.092 0.007 0.21-0.082 0.299l-6.337 6.337c-0.13 0.13-0.341 0.13-0.471 0l-2.191-2.191c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414l2.191 2.191c0.911 0.911 2.389 0.911 3.3-0l6.337-6.336c0.596-0.596 0.838-1.485 0.575-2.317-0.775-2.444-1.769-4.339-3.251-5.821s-3.377-2.477-5.821-3.251c-0.832-0.264-1.721-0.021-2.317 0.574l-6.337 6.337c-0.911 0.911-0.911 2.389 0 3.3l1.413 1.413-8.975 8.975c-0.175 0.175-0.273 0.413-0.273 0.66v4.667c0 0.515 0.418 0.933 0.933 0.933h4.667c0.515 0 0.933-0.418 0.933-0.933v-1.733h1.733c0.515 0 0.933-0.418 0.933-0.933v-1.733h2.4c0.515 0 0.933-0.418 0.933-0.933s-0.418-0.933-0.933-0.933h-3.333c-0.515 0-0.933 0.418-0.933 0.933v1.733h-1.733c-0.515 0-0.933 0.418-0.933 0.933v1.733h-2.8v-3.347l8.954-8.954c0.226-0.020 0.447-0.116 0.62-0.289 0.391-0.391 0.391-1.024 0-1.414l-2.191-2.191c-0.13-0.13-0.13-0.341 0-0.471l6.336-6.337c0.089-0.089 0.207-0.111 0.299-0.082z"></path>
                <path fill="currentColor" d="M22.667 9.333c0 0.736-0.597 1.333-1.333 1.333s-1.333-0.597-1.333-1.333c0-0.736 0.597-1.333 1.333-1.333s1.333 0.597 1.333 1.333z"></path>
            </symbol>
            <symbol id="filter-img-mobile" viewBox="0 0 32 32">
                <path fill="none" stroke="currentColor"  stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" stroke-width="2" d="M21.579 3.267h-11.157c-1.331 0-2.411 1.111-2.411 2.48v19.707c0 1.369 1.080 2.48 2.411 2.48h11.157c1.331 0 2.411-1.111 2.411-2.48v-19.707c0-1.369-1.080-2.48-2.411-2.48z"></path>
                <path fill="currentColor"  d="M16 24.632c0.095 0.006 0.189-0.008 0.278-0.040s0.171-0.082 0.24-0.147c0.069-0.065 0.124-0.143 0.161-0.23s0.057-0.181 0.057-0.275-0.019-0.188-0.057-0.275c-0.038-0.087-0.093-0.165-0.161-0.23s-0.151-0.115-0.24-0.147-0.184-0.046-0.278-0.040c-0.176 0.011-0.341 0.089-0.462 0.217s-0.188 0.298-0.188 0.475c0 0.176 0.067 0.346 0.188 0.475s0.286 0.206 0.462 0.217z"></path>
                <path fill="none" stroke="currentColor" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" stroke-width="2" d="M13.337 6.63h5.325M16 24.632c0.095 0.006 0.189-0.008 0.278-0.040s0.171-0.082 0.24-0.147c0.069-0.065 0.124-0.143 0.161-0.23s0.057-0.181 0.057-0.275-0.019-0.188-0.057-0.275c-0.038-0.087-0.093-0.165-0.161-0.23s-0.151-0.115-0.24-0.147-0.184-0.046-0.278-0.040c-0.176 0.011-0.341 0.089-0.462 0.217s-0.188 0.298-0.188 0.475c0 0.176 0.067 0.346 0.188 0.475s0.286 0.206 0.462 0.217z"></path>
            </symbol>
            <symbol id="filter-img-currency" viewBox="0 0 32 32">
                <path fill="currentColor" d="M20.762 12.19v-1.905h-3.809v-2.857h-1.905v2.857h-1.905c-0.505 0.001-0.989 0.201-1.346 0.558s-0.558 0.841-0.558 1.346v2.857c0.001 0.505 0.201 0.989 0.558 1.346s0.841 0.558 1.346 0.558h5.714v2.857h-7.619v1.905h3.81v2.857h1.905v-2.857h1.905c0.505-0.001 0.989-0.201 1.346-0.559s0.558-0.841 0.558-1.346v-2.857c-0.001-0.505-0.201-0.989-0.558-1.346s-0.841-0.558-1.346-0.558h-5.714v-2.857h7.619z"></path>
                <path fill="currentColor" d="M16 4.571c2.26 0 4.47 0.67 6.349 1.926s3.344 3.041 4.209 5.129c0.865 2.088 1.091 4.386 0.65 6.603s-1.529 4.253-3.128 5.852c-1.598 1.598-3.635 2.687-5.852 3.128s-4.515 0.215-6.603-0.65c-2.088-0.865-3.873-2.33-5.129-4.209s-1.926-4.089-1.926-6.349c0.009-3.028 1.216-5.93 3.357-8.072s5.043-3.348 8.072-3.357zM16 2.667c-2.637 0-5.215 0.782-7.408 2.247s-3.902 3.547-4.911 5.984c-1.009 2.436-1.273 5.117-0.759 7.704s1.784 4.962 3.649 6.827c1.865 1.865 4.24 3.135 6.827 3.649s5.267 0.251 7.704-0.759c2.436-1.009 4.519-2.718 5.984-4.911s2.247-4.771 2.247-7.408c-0.010-3.533-1.418-6.918-3.917-9.417s-5.884-3.906-9.417-3.917z"></path>
            </symbol>
            <symbol id="filter-img-console" viewBox="0 0 32 32">
                <path fill="currentColor" d="M7.91 25.313c-0.463 0.001-0.925-0.059-1.372-0.177-1.342-0.375-2.481-1.249-3.172-2.436s-0.879-2.592-0.524-3.913l2.22-8.241c0.173-0.667 0.48-1.293 0.904-1.843s0.955-1.010 1.563-1.355c0.592-0.336 1.247-0.553 1.925-0.639s1.368-0.040 2.028 0.136c0.702 0.191 1.356 0.522 1.92 0.973s1.026 1.012 1.357 1.647h2.477c0.33-0.636 0.791-1.198 1.356-1.649s1.219-0.782 1.921-0.971c0.66-0.176 1.35-0.222 2.028-0.136s1.333 0.304 1.925 0.639c0.605 0.344 1.135 0.803 1.558 1.348s0.732 1.168 0.909 1.831l2.22 8.26c0.36 1.325 0.174 2.736-0.52 3.927s-1.838 2.068-3.186 2.441c-0.66 0.176-1.35 0.222-2.028 0.136s-1.333-0.304-1.925-0.639c-0.606-0.343-1.137-0.801-1.56-1.347s-0.732-1.169-0.907-1.832l-0.171-0.82h-5.716l-0.219 0.802c-0.175 0.664-0.483 1.286-0.907 1.832s-0.954 1.004-1.56 1.347c-0.774 0.437-1.65 0.671-2.543 0.681zM10.12 8.532c-0.575 0.002-1.139 0.15-1.639 0.429-0.782 0.449-1.351 1.183-1.581 2.042l-2.22 8.241c-0.232 0.849-0.115 1.753 0.327 2.519s1.173 1.33 2.036 1.574c0.417 0.111 0.852 0.141 1.28 0.086s0.842-0.191 1.216-0.403c0.389-0.22 0.73-0.514 1.001-0.865s0.469-0.751 0.58-1.177l0.591-2.191h8.574l0.581 2.191c0.113 0.425 0.311 0.825 0.583 1.175s0.611 0.645 0.999 0.867c0.376 0.211 0.79 0.348 1.22 0.403s0.867 0.025 1.285-0.086c0.864-0.241 1.596-0.807 2.036-1.573s0.554-1.672 0.317-2.52l-2.22-8.241c-0.111-0.425-0.306-0.825-0.576-1.175s-0.608-0.645-0.995-0.866c-0.376-0.211-0.791-0.348-1.221-0.403s-0.867-0.025-1.285 0.086c-0.517 0.144-0.992 0.407-1.385 0.767s-0.692 0.806-0.873 1.302l-0.229 0.615h-5.049l-0.229-0.615c-0.183-0.497-0.483-0.943-0.878-1.303s-0.871-0.623-1.389-0.766c-0.28-0.074-0.568-0.111-0.857-0.112z"></path>
                <path fill="currentColor" d="M10.282 15.991c-0.377 0-0.745-0.109-1.059-0.314s-0.558-0.496-0.702-0.837c-0.144-0.341-0.182-0.716-0.108-1.077s0.255-0.694 0.521-0.955c0.266-0.261 0.606-0.438 0.976-0.51s0.753-0.035 1.101 0.106c0.348 0.141 0.646 0.38 0.855 0.687s0.321 0.667 0.321 1.036c0 0.495-0.201 0.969-0.558 1.319s-0.842 0.546-1.347 0.546z"></path>
                <path fill="currentColor" d="M21.714 13.194c0.526 0 0.953-0.417 0.953-0.932s-0.426-0.932-0.953-0.932c-0.526 0-0.953 0.417-0.953 0.932s0.427 0.932 0.953 0.932z"></path>
                <path fill="currentColor" d="M21.714 16.923c0.526 0 0.953-0.417 0.953-0.932s-0.426-0.932-0.953-0.932-0.953 0.417-0.953 0.932c0 0.515 0.427 0.932 0.953 0.932z"></path>
                <path fill="currentColor" d="M19.809 15.059c0.526 0 0.953-0.417 0.953-0.932s-0.426-0.932-0.953-0.932-0.953 0.417-0.953 0.932c0 0.515 0.427 0.932 0.953 0.932z"></path>
                <path fill="currentColor" d="M23.619 15.059c0.526 0 0.953-0.417 0.953-0.932s-0.427-0.932-0.953-0.932c-0.526 0-0.953 0.417-0.953 0.932s0.427 0.932 0.953 0.932z"></path>
            </symbol>
        </defs>
    </svg>
</template>
  
<script>
import SlideUpDown from '/webpack-assets/vue/components/SlideUpDown.vue';
import axios from "axios";

  export default {
    name: 'HeaderSearch',
    emits: ['search-active', 'toggle-filter-catalog'],
    components: {
      SlideUpDown
    },
    props: {
        mobile: {
            type: Boolean,
            default: false,
        },
        language: {
            type: String,
            default: 'en',
        },
        isGuest: {
            type: Boolean,
            default: false,
        },
        isFilterCatalogActive: {
            type: Boolean,
            default: false,
        },
        isSearchResultVisibleProp: {
            type: Boolean,
            default: false,
        },
        btnPreloaderSubmitProp: {
            type: Boolean,
            default: false,
        },
        categories: {
            type: Object,
            default: () => {},
        },
    },
    data() {
      return {
        currency: window.common.currency.symbol,
        btnPreloaderSubmit: false,
        searchResultCount: null,
        searchResultProducts: null,
        linkViewAll: null,
        isSearchActive: false,
        isSearchResultVisible: false,
        isSearchResultShow: false,
        animatedPlaceholder: true,
        searchQuery: '',
        currentRequest: null,
        searchTimeout: null,
        activeFilterChips: null
      };
    },
    mounted() {
        setTimeout(()=>{
            this.animatedPlaceholder = false;
        }, 500)
    },
    computed: {
        filteredCategories() {
            if (!this.categories?.list) return []

            return Object.values(this.categories.list).flatMap(group =>
                Object.values(group.items || {}).map(item => ({
                    ...item,
                    category_icon: this.getCategoryIcon(item.index)
                }))
            )
        }
    },
    methods: {
        getCategoryIcon(index) {
            const map = {
            1: 'filter-img-keys',
            2: 'filter-img-currency',
            3: 'filter-img-console',
            4: 'filter-img-mobile',
            5: 'filter-img-software',
            6: 'filter-img-software',
            7: 'filter-img-top-up',
            8: 'filter-img-game-points'
            }

            return map[index] || null
        },
        choseFilterChips(item) {
            console.log(item)
            this.activeFilterChips = item;
            this.$emit('toggle-filter-catalog')
        },
        formatCurrency(amount) {
            if(amount < 0) amount = 0;
            const number = Number(amount).toFixed(2);
            const [wholePart, fractionPart] = number.split('.');

            const wholeWithSpaces = wholePart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
            return `${this.currency} ${wholeWithSpaces}.${fractionPart}`;
        },
        handleSearchInput() {
            const query = this.searchQuery.trim();

            if (query !== '') {
                this.$emit('search-active', true);
                this.isSearchActive = true;
                this.handleClasses(true)
                if (query.length > 2) {
                    clearTimeout(this.searchTimeout);
                    this.btnPreloaderSubmit = true;
                    this.searchTimeout = setTimeout(() => {
                        this.sendSearchRequest(query);
                    }, 300);
                } else {
                    this.isSearchResultShow = false;
                    this.isSearchResultVisible = false;
                }
            } else {
                this.resetSearchState();
            }
        },
        handleSearch(){
            this.btnPreloaderSubmit = true;

            if(this.searchQuery){
                window.location.href = `/products?name=${encodeURIComponent(this.searchQuery)}`;
            } else {
                window.location.href = '/products?name=';
            }
        },
        handleClasses(ifAdd) {
            const action = ifAdd ? 'add' : 'remove';
            document.querySelector("body").classList[action]("noscroll");
        },
        sendSearchRequest(query) {
            const requestData = {
                name: query,
                'per-page': 20,
                ajax: 1,
            };

            if (this.activeFilterChips) {
                requestData.category_id = this.activeFilterChips?.category_id; 
            }

            if (this.currentRequest) {
                this.currentRequest.abort();
            }
                  
            this.currentRequest = new AbortController();

            axios({
                method: 'get',
                url: '/' + this.language + '/api-products',
                params: requestData,
                signal: this.currentRequest.signal,
            })
            .then((response) => {
                if (!this.isSearchActive) return
                this.searchResultCount = response.data.meta.total_count;
                this.searchResultProducts = response.data.data;
                //this.linkViewAll = response.data.view_all;
                this.isSearchResultVisible = true;
                this.btnPreloaderSubmit = false;
                this.$emit('search-active', true);

                this.isSearchResultShow = true;
            })
            .catch((error) => {
                if (error.name === 'CanceledError') {
                    console.log(error.name);
                } else {
                    console.error(error);
                    this.resetSearchState();
                }
            })
            .finally(() => {
                this.currentRequest = null;
            });
        },
        resetSearchState() {
            this.$emit('search-active', false);
            this.searchQuery = '';
            this.isSearchActive = false;
            this.isSearchResultVisible = false;
            this.btnPreloaderSubmit = false;
            this.isSearchResultShow = false;
            this.searchResultProducts = null;
            this.searchResultCount = null;
            this.handleClasses(false)
        },
    },
    watch: {
        // isSearchResultVisibleProp() {
        //     const query = this.searchQuery.trim();
        //     if (query.length > 2) {
        //         this.isSearchResultVisible = this.isSearchResultVisibleProp;
        //         if(!this.isSearchResultVisible){
        //             this.isSearchResultShow = false;
        //             this.searchQuery = '';
        //             this.isSearchActive = false;
        //         }
        //     }
        // },
        isSearchResultVisibleProp(newVal) {
            this.isSearchResultVisible = newVal;

            if (!newVal) {
                this.isSearchResultShow = false;
                this.isSearchActive = false;
            }
        }
    }
  };
  </script>